'use strict';

var AppendCaret = function(config) {

  var self = this;
  var $item = $(config.item);
  var $link = $(config.link);
  var $subnav = $(config.subnav);
  var caret = '<svg class="caret-icon" xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="-1 -1 11 9"><path fill="#0D0810" d="M7.8 1L4.6 5.5 1.4 1"/></svg>';

  self.parseItems = function() {
    $item.each(function() {
      var $this = $(this);
      var _$link = $this.find($link);
      var _$subnav = $this.find($subnav);

      if (_$subnav.length) {
        self.appendCaretEl(_$link);
      }
    });
  }

  self.appendCaretEl = function(_$link) {
    _$link.append(caret);
  }

  self.init = function() {
    self.parseItems();
  }
};

module.exports = AppendCaret;
